/**
 * SPOILER ALERT
 *
 * This file contains the solutions to each game of Pördl
 */

export const WORDS = [
    'april',
    'sippe',
    'linse',
    'zuber',
    'eklat',
    'zange',
    'jäger',
    'honig',
    'porto',
    'fazit',
    'kombi',
    'visum',
    'zelle',
    'junge',
    'fuchs',
    'woran',
    'ziele',
    'böser',
    'grell',
    'lagen',
    'sitte',
    'blond',
    'leber',
    'ritze',
    'laute',
    'kurse',
    'damen',
    'marge',
    'komet',
    'wille',
    'diele',
    'umweg',
    'messe',
    'punkt',
    'modem',
    'leben',
    'salto',
    'gegen',
    'angst',
    'kante',
    'reibe',
    'mumie',
    'agave',
    'kreis',
    'staub',
    'salze',
    'lunge',
    'steak',
    'kufen',
    'durch',
    'akten',
    'davor',
    'traum',
    'kugel',
    'mobil',
    'devot',
    'akkus',
    'bongo',
    'zitat',
    'minze',
    'münze',
    'pixel',
    'circa',
    'hexer',
    'flott',
    'doofe',
    'warum',
    'tenor',
    'zeuge',
    'spreu',
    'fasan',
    'zunft',
    'rippe',
    'vater',
    'silbe',
    'hauen',
    'stuss',
    'wenig',
    'dauer',
    'halbe',
    'dünen',
    'flora',
    'intim',
    'desto',
    'kanne',
    'image',
    'union',
    'idiot',
    'reise',
    'agent',
    'grund',
    'penis',
    'seite',
    'feind',
    'runde',
    'hagel',
    'lauge',
    'löwen',
    'seife',
    'remis',
    'spüle',
    'druck',
    'schub',
    'alpen',
    'hecke',
    'beute',
    'labil',
    'rache',
    'tiere',
    'venen',
    'kabel',
    'busch',
    'heute',
    'famos',
    'zwirn',
    'ulkig',
    'niete',
    'lasso',
    'luxus',
    'adern',
    'asche',
    'fahne',
    'treff',
    'ethik',
    'magie',
    'klima',
    'umbau',
    'kakao',
    'sehne',
    'brett',
    'enkel',
    'juwel',
    'viren',
    'kniff',
    'kehle',
    'minus',
    'locke',
    'kappe',
    'fleck',
    'maden',
    'dusel',
    'kraus',
    'steif',
    'kippe',
    'rumpf',
    'harfe',
    'trend',
    'eklig',
    'chlor',
    'riese',
    'seile',
    'kiosk',
    'zebra',
    'dünen',
    'zinne',
    'saudi',
    'ebene',
    'santa',
    'herde',
    'sound',
    'wehen',
    'hauch',
    'braun',
    'abend',
    'idyll',
    'eisen',
    'segel',
    'immun',
    'argen',
    'brote',
    'salon',
    'geben',
    'ohren',
    'viele',
    'besen',
    'pfade',
    'wiese',
    'gören',
    'trafo',
    'bange',
    'apfel',
    'brise',
    'vasen',
    'reell',
    'notar',
    'gleis',
    'quere',
    'sport',
    'puder',
    'moral',
    'furie',
    'näher',
    'büros',
    'sauer',
    'wovor',
    'prall',
    'aktiv',
    'stadt',
    'wippe',
    'human',
    'heran',
    'recke',
    'spitz',
    'krise',
    'ringe',
    'lügen',
    'faden',
    'risse',
    'regie',
    'lange',
    'wobei',
    'eifer',
    'danke',
    'semit',
    'immer',
    'übler',
    'halme',
    'weide',
    'legen',
    'eifel',
    'karos',
    'piano',
    'galle',
    'makel',
    'erbin',
    'rüben',
    'biene',
    'spott',
    'stern',
    'milch',
    'trunk',
    'sturm',
    'bauen',
    'draht',
    'lenze',
    'könig',
    'saufe',
    'pedal',
    'somit',
    'essig',
    'glied',
    'gagen',
    'getue',
    'syrer',
    'heiss',
    'brust',
    'breit',
    'sucht',
    'stuhl',
    'eilen',
    'taufe',
    'sinne',
    'demut',
    'statt',
    'pfand',
    'stets',
    'wurst',
    'weben',
    'felge',
    'weich',
    'typus',
    'duett',
    'gaben',
    'video',
    'kampf',
    'kurie',
    'nabel',
    'extra',
    'kluft',
    'algen',
    'grobe',
    'waben',
    'still',
    'knien',
    'pferd',
    'orgel',
    'senat',
    'vorab',
    'blatt',
    'käfig',
    'masse',
    'quasi',
    'gnade',
    'kasse',
    'qualm',
    'unmut',
    'stile',
    'luchs',
    'arena',
    'meile',
    'chaos',
    'pfeil',
    'antik',
    'jeder',
    'kegel',
    'busse',
    'hinzu',
    'meere',
    'faser',
    'paare',
    'dinar',
    'macke',
    'brief',
    'eilig',
    'eckig',
    'starr',
    'jause',
    'tauft',
    'taler',
    'zweit',
    'wider',
    'hocke',
    'serie',
    'stopp',
    'pirat',
    'droge',
    'zivil',
    'enzym',
    'laden',
    'ruhen',
    'weile',
    'ziege',
    'lotse',
    'scheu',
    'strom',
    'stunk',
    'essen',
    'genie',
    'rival',
    'wieso',
    'korea',
    'murks',
    'selig',
    'treue',
    'satin',
    'hitze',
    'eiter',
    'szene',
    'darum',
    'modul',
    'zitze',
    'elite',
    'ehren',
    'beule',
    'ohren',
    'knick',
    'fluch',
    'raten',
    'beere',
    'biwak',
    'fiber',
    'welch',
    'sorge',
    'stirn',
    'keine',
    'blech',
    'offen',
    'speck',
    'venus',
    'sache',
    'pacht',
    'erbse',
    'melke',
    'panik',
    'tobak',
    'luder',
    'rufen',
    'texte',
    'legal',
    'regal',
    'buben',
    'weite',
    'pflug',
    'klick',
    'daten',
    'sauce',
    'holen',
    'plage',
    'enden',
    'glatt',
    'armee',
    'monat',
    'teuer',
    'hurra',
    'glanz',
    'mauer',
    'mafia',
    'knapp',
    'duell',
    'rosen',
    'heine',
    'total',
    'pille',
    'kunst',
    'emsig',
    'filme',
    'zicke',
    'banjo',
    'lauch',
    'engel',
    'dinge',
    'sporn',
    'gramm',
    'nadel',
    'stand',
    'rente',
    'namen',
    'tisch',
    'orkan',
    'ranke',
    'kerbe',
    'farbe',
    'karre',
    'rauhe',
    'eiche',
    'kniee',
    'gruft',
    'pfund',
    'jeden',
    'vorne',
    'leder',
    'nagel',
    'durst',
    'laune',
    'staat',
    'klamm',
    'skala',
    'boxen',
    'zofen',
    'feder',
    'album',
    'kraut',
    'kreuz',
    'krieg',
    'lokal',
    'einig',
    'linie',
    'uhren',
    'voran',
    'leute',
    'kerle',
    'tempo',
    'klotz',
    'paket',
    'bosse',
    'wovon',
    'sesam',
    'feier',
    'geber',
    'wucht',
    'satan',
    'obhut',
    'yacht',
    'dreck',
    'lilie',
    'ecken',
    'mensa',
    'email',
    'meise',
    'wunde',
    'mimik',
    'spann',
    'these',
    'knall',
    'kopie',
    'bauch',
    'witwe',
    'kelle',
    'stamm',
    'dekan',
    'stich',
    'maske',
    'forum',
    'koran',
    'untat',
    'sturz',
    'wachs',
    'abweg',
    'arsch',
    'tiger',
    'henne',
    'wesen',
    'preis',
    'stroh',
    'knopf',
]

// AB HIER SIND DIE WÖRTER NICHT GEPRÜFT.
// Die Wortliste enthält englische Wörter oder Ortsnamen
// und Doppelvokale statt Umlaute. Diese Wörter sollten entfernt werden.
/*

   
  
    'stoss',
    'leiht',
    'kater',
    'kerns',
    'obige',
    'prags',
    'ebnen',
    'dufte',
    'reale',
    'creme',
    'grast',
    'rolle',
    'kamel',
    'scher',
    'drauf',
    'arosa',
    'gutem',
    'nikon',
    'zwist',
    'sagen',
    'bazar',
    'riege',
    'coupe',
    'marco',
    'freue',
    'niere',
    'tuend',
    'polle',
    'wankt',
    'sicht',
    'babys',
    'klubs',
    'zuvor',
    'stils',
    'rohem',
    'reine',
    'kamst',
    'senke',
    'gifte',
    'organ',
    'platt',
    'geist',
    'lacht',
    'steil',
    'leibe',
    'ticks',
    'anzug',
    'musse',
    'kinos',
    'lasse',
    'anwar',
    'sitze',
    'tutor',
    'ethos',
    'kupee',
    'bande',
    'tappt',
    'riedl',
    'humus',
    'kuche',
    'tadel',
    'aurel',
    'kongo',
    'ideen',
    'menge',
    'dosen',
    'baute',
    'touch',
    'pisse',
    'saege',
    'geiss',
    'negro',
    'ocker',
    'tritt',
    'zuege',
    'suite',
    'stege',
    'super',
    'taube',
    'trete',
    'jaffa',
    'puste',
    'tauge',
    'marke',
    'notiz',
    'fluss',
    'greis',
    'ferne',
    'oesen',
    'discs',
    'tuben',
    'lasen',
    'harte',
    'motor',
    'komik',
    'hupst',
    'shell',
    'ritus',
    'huebe',
    'moewe',
    'rohre',
    'fabel',
    'ritzt',
    'eides',
    'mache',
    'rasta',
    'parat',
    'purem',
    'hoere',
    'boxte',
    'liege',
    'passt',
    'makro',
    'foppe',
    'flair',
    'duckt',
    'taste',
    'sande',
    'crash',
    'reibt',
    'villa',
    'kopfe',
    'oelte',
    'huren',
    'kubas',
    'wache',
    'insel',
    'haare',
    'wurms',
    'civil',
    'kuehl',
    'wedel',
    'apsis',
    'chase',
    'falbe',
    'euler',
    'ungar',
    'abart',
    'lobte',
    'logis',
    'apart',
    'arien',
    'ponte',
    'busen',
    'krach',
    'magen',
    'ruhig',
    'netal',
    'munze',
    'vegas',
    'lippe',
    'sirup',
    'grete',
    'giant',
    'gutes',
    'fehde',
    'salve',
    'tenne',
    'reger',
    'lager',
    'erzes',
    'felix',
    'blase',
    'dumme',
    'flugs',
    'wanke',
    'botet',
    'titan',
    'wanze',
    'fusst',
    'maori',
    'helme',
    'urans',
    'pumpe',
    'mitte',
    'tagen',
    'haute',
    'koord',
    'foppt',
    'erdol',
    'kings',
    'wenns',
    'nennt',
    'deine',
    'petra',
    'nehru',
    'wiege',
    'meine',
    'canon',
    'marge',
    'foens',
    'saite',
    'paste',
    'takle',
    'takte',
    'amors',
    'aspik',
    'gicht',
    'knien',
    'stout',
    'karat',
    'turme',
    'gelde',
    'stark',
    'derer',
    'novum',
    'nehme',
    'knast',
    'raunt',
    'letzt',
    'brave',
    'slums',
    'feilt',
    'autos',
    'heino',
    'logik',
    'pfaue',
    'merkt',
    'bezug',
    'garni',
    'blick',
    'wirst',
    'prinz',
    'wuste',
    'kinns',
    'opfer',
    'trieb',
    'halte',
    'klipp',
    'lerne',
    'faust',
    'keule',
    'sinus',
    'monde',
    'zakel',
    'kochs',
    'sehnt',
    'mager',
    'liest',
    'hockt',
    'fluge',
    'orgie',
    'atari',
    'labor',
    'deren',
    'zogen',
    'arten',
    'homer',
    'tatet',
    'gouda',
    'ochse',
    'walls',
    'wagen',
    'sankt',
    'quitt',
    'wollt',
    'siegs',
    'kommt',
    'flohs',
    'dunst',
    'licht',
    'allem',
    'robbe',
    'viert',
    'bucht',
    'tunke',
    'hoert',
    'kauft',
    'kabul',
    'kraft',
    'teils',
    'klein',
    'roete',
    'flink',
    'kreta',
    'banal',
    'duese',
    'volks',
    'lauer',
    'links',
    'hirse',
    'verdi',
    'joerg',
    'kokon',
    'dakar',
    'tulpe',
    'salem',
    'maeht',
    'rosig',
    'piper',
    'lotus',
    'radau',
    'index',
    'dolch',
    'junis',
    'eupen',
    'nahen',
    'backe',
    'datei',
    'ekzem',
    'geier',
    'apfel',
    'krank',
    'wetzt',
    'ulmen',
    'russe',
    'quarz',
    'croix',
    'zucke',
    'hupte',
    'gotts',
    'leser',
    'gabel',
    'harns',
    'rangt',
    'reite',
    'scham',
    'gibst',
    'edler',
    'nutze',
    'genre',
    'palme',
    'ulkst',
    'parke',
    'assen',
    'tests',
    'mikro',
    'ricke',
    'bitte',
    'adels',
    'floss',
    'lockt',
    'hafte',
    'firma',
    'slave',
    'jahre',
    'flach',
    'armem',
    'arher',
    'hobet',
    'irrst',
    'leimt',
    'jemen',
    'kanal',
    'kobra',
    'abzog',
    'dachs',
    'worum',
    'fango',
    'plump',
    'waren',
    'poker',
    'sofia',
    'reimt',
    'banne',
    'kaffs',
    'prado',
    'adeln',
    'gauda',
    'urins',
    'reime',
    'rollt',
    'fatal',
    'sorte',
    'trick',
    'orion',
    'stier',
    'keime',
    'salat',
    'codex',
    'komme',
    'bombe',
    'teert',
    'meter',
    'doris',
    'dover',
    'celle',
    'blume',
    'gehen',
]
*/
